import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule }   from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MeasurementsComponent } from './measurements/measurements.component';
import { MeasureComponent } from './measure/measure.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi }    from '@angular/common/http';
import { ExamsbarComponent } from './examsbar/examsbar.component';
import { ExamComponent } from './exam/exam.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule } from '@angular/material/input';
import {MatExpansionModule} from '@angular/material/expansion';
import {NgFor} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatBadgeModule} from '@angular/material/badge';
import { MskComponent } from './msk/msk.component';
import { MskSoftTissuesComponent } from './msk-soft-tissues/msk-soft-tissues.component';
import { NeckScanComponent } from './neck-scan/neck-scan.component';






import { LoginComponent } from './login/login.component';
import { PatientsComponent } from './patients/patients.component';
import { PaginationControlsComponent } from './pagination-controls/pagination-controls.component';
import { BottombarComponent } from './bottombar/bottombar.component';
import { PatdetailsComponent } from './patdetails/patdetails.component';
import { PatexamsComponent } from './patexams/patexams.component';
import { PatientRedirectComponent } from './patient-redirect/patient-redirect.component';
import { DocpanelComponent } from './docpanel/docpanel.component';
import { PregnancyComponent } from './pregnancy/pregnancy.component';
import { PlacentaComponent } from './placenta/placenta.component';
import { AnatomyComponent } from './anatomy/anatomy.component';
import { SummaryComponent } from './summary/summary.component';
import { FinancialStatusComponent } from './financial-status/financial-status.component';
import { ExamPayerComponent } from './exam-payer/exam-payer.component';
import { NgChartsModule, ThemeService } from 'ng2-charts';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);
import { DopplerComponent } from './doppler/doppler.component';
import { DoppleritemComponent } from './doppleritem/doppleritem.component';
import { NTComponent } from './nt/nt.component';
import { PrintComponent } from './print/print.component';
import { PrintmeasureComponent } from './printmeasure/printmeasure.component';
import { GalleryComponent } from './gallery/gallery.component';
import { LightboxModule } from 'ngx-lightbox';
import { ChartsComponent } from './charts/charts.component';
import { SystemprintComponent } from './systemprint/systemprint.component';
import { DopplerprintComponent } from './dopplerprint/dopplerprint.component';
import { PrintoptsComponent } from './printopts/printopts.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { AutotextComponent } from './autotext/autotext.component';
import { AutotextRowComponent } from './autotext-row/autotext-row.component';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatDatepickerModule,} from '@angular/material/datepicker';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatMenuModule} from '@angular/material/menu';
import {DateAdapter,MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
import { GalleryboxComponent } from './gallerybox/gallerybox.component';
import { GenradioComponent } from './genradio/genradio.component';
import { InboxComponent } from './inbox/inbox.component';
import { InterceptorService } from './interceptor.service';
import { CommerrorComponent } from './commerror/commerror.component';
import { DiagnosesComponent } from './diagnoses/diagnoses.component';
import { UterusComponent } from './uterus/uterus.component';
import { OvariesComponent } from './ovaries/ovaries.component';
import { RemotevideoComponent } from './remotevideo/remotevideo.component';
import { LoginboxComponent } from './loginbox/loginbox.component';
import { GYNgeneralComponent } from './gyngeneral/gyngeneral.component';
import { ClosepregnancyComponent } from './closepregnancy/closepregnancy.component';
import { SendLinkComponent } from './send-link/send-link.component';
import { SearchboxComponent } from './searchbox/searchbox.component';
import { ConsultationComponent } from './consultation/consultation.component';
import { ClinicTemplatesComponent } from './clinic-templates/clinic-templates.component';
import { ClinicAutotextComponent } from './clinic-autotext/clinic-autotext.component';
import { ClinicExamBuilderComponent } from './clinic-exam-builder/clinic-exam-builder.component';
import { ClinicExamComponent } from './clinic-exam/clinic-exam.component';
import { ClinicFieldAutotextComponent } from './clinic-field-autotext/clinic-field-autotext.component';
import { ClinicExamPrintComponent } from './clinic-exam-print/clinic-exam-print.component';
import { ExamDiagnosesComponent } from './exam-diagnoses/exam-diagnoses.component';
import { HraDiagramComponent } from './hra-diagram/hra-diagram.component';
import { ClinicPreviousExamComponent } from './clinic-previous-exam/clinic-previous-exam.component';
import { AutotextPanelComponent } from './autotext-panel/autotext-panel.component';
import { ClinicAutotextPopupComponent } from './clinic-autotext-popup/clinic-autotext-popup.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { WeightAssessmentComponent } from './weight-assessment/weight-assessment.component';
import { CardioGeneralComponent } from './cardio/cardio-general/cardio-general.component';
import { TwodComponent } from './cardio/twod/twod.component';
import { CardioDopplerComponent } from './cardio/cardio-doppler/cardio-doppler.component';
import { CardioPrintComponent } from './cardio/cardio-print/cardio-print.component';
import { CardioTissueDopComponent } from './cardio/cardio-tissue-dop/cardio-tissue-dop.component';
import { FetalechoComponent } from './fetalecho/fetalecho.component';
import { FetalechoitemComponent } from './fetalechoitem/fetalechoitem.component';
import { FetalmeasureComponent } from './fetalmeasure/fetalmeasure.component';
import { MedicalhistoryComponent } from './medicalhistory/medicalhistory.component';
import { MedicalhistoryitemComponent } from './medicalhistoryitem/medicalhistoryitem.component';
import { PreparationComponent } from './Gastro/preparation/preparation.component';
import { FindingsComponent } from './Gastro/findings/findings.component';
import { PathologiesComponent } from './Gastro/pathologies/pathologies.component';
import { PathologyScanPopupComponent } from './Gastro/pathology-scan-popup/pathology-scan-popup.component';
import { GastroSummaryComponent } from './Gastro/gastro-summary/gastro-summary.component';
import { UsGeneralPrintComponent } from './Gastro/usgeneral-print/usgeneral-print.component';
import { EndoscopyPrintComponent } from './endoscopy/endoscopy-print/endoscopy-print.component';
import { PatformsComponent } from './Gastro/patforms/patforms.component';
import { DetailFindingComponent } from './Gastro/findings/detail-finding/detail-finding.component';
import { PatformsitemComponent } from './Gastro/patforms/patformsitem/patformsitem.component';
import { GastroPrintoptsComponent } from './Gastro/gastro-printopts/gastro-printopts.component';
import { GsprintFormComponent } from './Gastro/gsprint-form/gsprint-form.component';
import { CustomheaderComponent } from './customheader/customheader.component';
import { CardioSummaryComponent } from './cardio/cardio-summary/cardio-summary.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { CardioFindingsComponent } from './cardio/cardio-findings/cardio-findings.component';
import { PaymentComponent } from './misc/payment/payment.component';
import { StatsComponent } from './stats/stats.component';
import { PrintstatsComponent } from './Gastro/printstats/printstats.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { GeninputComponent } from './geninput/geninput.component';
import { TotpboxComponent } from './totpbox/totpbox.component';
import { VersionPopupComponent } from './version-popup/version-popup.component';
import { AnnouncementHostComponent } from './announcement-host/announcement-host.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SearchtextComponent } from './searchtext/searchtext.component';
import { TimeoutComponent } from './Gastro/patforms/timeout/timeout.component';
import { AdmissionComponent } from './Gastro/patforms/admission/admission.component';
import { GastroProcedureComponent } from './Gastro/gastro-procedure/gastro-procedure.component';
import { CalexamsComponent } from './calexams/calexams.component';
import { PrintreportComponent } from './printreport/printreport.component';
import { PrintcalendarComponent } from './printcalendar/printcalendar.component';
import { InformconcentComponent } from './informconcent/informconcent.component';
import { CardioFlowMeasComponent } from './cardio/cardio-flow-meas/cardio-flow-meas.component';
import { LimitsComponent } from './limits/limits.component';
import { AbdomenusComponent } from './abdomenus/abdomenus.component';
import { UssummaryComponent } from './ussummary/ussummary.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { ReleaseComponent } from './release/release.component';
import { PrintPathologyFormComponent } from './print-pathology-form/print-pathology-form.component';
import { TranslateresultPipe } from './translateresult.pipe';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { ConsentFormComponent } from './consent-form/consent-form.component';
import { TranslateDayPipe } from './translate-day.pipe';
import { HemorrhoidsTreatmentComponent } from './hemorrhoids-treatment/hemorrhoids-treatment.component';
import { GuideComponent } from './guide/guide.component';
import { BarcodeComponent } from './barcode/barcode.component';
import { MessengerReportComponent } from './messenger-report/messenger-report.component';
import { LabresultsComponent } from './labresults/labresults.component';
import { LabreportComponent } from './labreport/labreport.component';
import { BiopsystatsComponent } from './biopsystats/biopsystats.component';
import { CustomTooltipComponent } from './custom-tooltip.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TrainingHubComponent } from './training-hub/training-hub.component';
import { PrescriptionDialogComponent, PrescriptionLangDialogComponent } from './prescription/prescription-dialog.component';
import { PrescriptionPrintComponent } from './prescription/prescription-print/prescription-print.component';
import { BloodTestReferralDialogComponent, ReferralLangDialogComponent } from './blood-test-referral/blood-test-referral-dialog.component';
import { BloodTestReferralPrintComponent } from './blood-test-referral/blood-test-referral-print/blood-test-referral-print.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EndoscopySummaryComponent } from './endoscopy/endoscopy-summary/endoscopy-summary.component';
import { PatDocumentsComponent } from './pat-documents/pat-documents.component';
import { UsgConsentFormComponent } from './usg-consent-form/usg-consent-form.component';
import { PrintUsgConsentComponent } from './print-usg-consent/print-usg-consent.component';
import { SendQuestionnaireComponent } from './send-questionnaire/send-questionnaire.component';
import { ConsentFormsComponent } from './consent-forms/consent-forms.component';


//import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${environment.appVersion}`);
}
@NgModule({ declarations: [
        AppComponent,
        PaginationControlsComponent,
        MeasurementsComponent,
        MeasureComponent,
        ExamsbarComponent,
        ExamComponent,
        LoginComponent,
        PatientsComponent,
        BottombarComponent,
        PatdetailsComponent,
        PatexamsComponent,
        PatientRedirectComponent,
        DocpanelComponent,
        PregnancyComponent,
        PlacentaComponent,
        AnatomyComponent,
        SummaryComponent,
        FinancialStatusComponent,
        ExamPayerComponent,
        DopplerComponent,
        DoppleritemComponent,
        NTComponent,
        PrintComponent,
        PrintmeasureComponent,
        GalleryComponent,
        ChartsComponent,
        SystemprintComponent,
        DopplerprintComponent,
        PrintoptsComponent,
        AutotextComponent,
        AutotextRowComponent,
        GalleryboxComponent,
        GenradioComponent,
        InboxComponent,
        CommerrorComponent,
        DiagnosesComponent,
        UterusComponent,
        OvariesComponent,
        RemotevideoComponent,
        LoginboxComponent,
        GYNgeneralComponent,
        ClosepregnancyComponent,
        SendLinkComponent,
        SearchboxComponent,
        ConsultationComponent,
        ClinicTemplatesComponent,
        ClinicAutotextComponent,
        ClinicExamBuilderComponent,
        ClinicExamComponent,
        ClinicFieldAutotextComponent,
        ClinicExamPrintComponent,
        ExamDiagnosesComponent,
        HraDiagramComponent,
        ClinicPreviousExamComponent,
        AutotextPanelComponent,
        ClinicAutotextPopupComponent,
        WeightAssessmentComponent,
        CardioGeneralComponent,
        TwodComponent,
        CardioDopplerComponent,
        CardioPrintComponent,
        CardioTissueDopComponent,
        FetalechoComponent,
        FetalechoitemComponent,
        FetalmeasureComponent,
        MedicalhistoryComponent,
        MedicalhistoryitemComponent,
        PreparationComponent,
        FindingsComponent,
        PathologiesComponent,
        PathologyScanPopupComponent,
        PathologyScanPopupComponent,
        GastroSummaryComponent,
        UsGeneralPrintComponent,
        EndoscopyPrintComponent,
        PatformsComponent,
        DetailFindingComponent,
        PatformsitemComponent,
        GastroPrintoptsComponent,
        GsprintFormComponent,
        CustomheaderComponent,
        CardioSummaryComponent,
        TextBoxComponent,
        CardioFindingsComponent,
        PaymentComponent,
        StatsComponent,
        PrintstatsComponent,
        ProcedureComponent,
        GeninputComponent,
        TotpboxComponent,
        VersionPopupComponent,
        ForgotPasswordComponent,
        SearchtextComponent,
        TimeoutComponent,
        AdmissionComponent,
        GastroProcedureComponent,
        CalexamsComponent,
        PrintreportComponent,
        PrintcalendarComponent,
        InformconcentComponent,
        CardioFlowMeasComponent,
        LimitsComponent,
        AbdomenusComponent,
        UssummaryComponent,
        RecoveryComponent,
        ReleaseComponent,
        PrintPathologyFormComponent,
        TranslateresultPipe,
        WaitingListComponent,
        ConsentFormComponent,
        TranslateDayPipe,
        HemorrhoidsTreatmentComponent,
        GuideComponent,
        BarcodeComponent,
        MessengerReportComponent,
        LabresultsComponent,
        LabreportComponent,
        BiopsystatsComponent,
        CustomTooltipComponent,
        MskComponent,
        MskSoftTissuesComponent,
        NeckScanComponent,
        PrivacyPolicyComponent,
        PrescriptionDialogComponent,
        TrainingHubComponent,
        PrescriptionLangDialogComponent,
        PrescriptionPrintComponent,
        BloodTestReferralDialogComponent,
        ReferralLangDialogComponent,
        BloodTestReferralPrintComponent,
        EndoscopySummaryComponent,
        PatDocumentsComponent,
        UsgConsentFormComponent,
        PrintUsgConsentComponent,
        SendQuestionnaireComponent,
        ConsentFormsComponent,
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgChartsModule,
        LightboxModule,
        MatDatepickerModule,
        MatTableModule,
        MatIconModule,
        MatMomentDateModule,
        MatTooltipModule,
        MatMenuModule,
        MatDialogModule,
        MatCheckboxModule,
        AngularEditorModule,
        CKEditorModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
        MatSelectModule,
        MatBadgeModule,
        MatProgressBarModule,
        DragDropModule,
        NgFor,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        AnnouncementHostComponent], providers: [
        MatDatepickerModule,
        MatTooltipModule,
        ThemeService,
        { provide: MAT_DATE_LOCALE, useValue: 'he-IL' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
